import {loginUrl, languagesMenu} from '../../utils';
import {scrollDropdownWhenItemsAmountIsBiggerThen} from '../../data/constants.json';
import {links, linkContent, homeLink} from '../common';
import * as css from './desktop.scss';
import iconsGlobe from '../svg/globe';
import iconsArrowDown from '../svg/arrowDown';
import {defaultProfileImage} from '../../config';

const dropdown = (items, {title = '', iconClass = '', icon = null, tabIndex = null, tabIndexForButton = tabIndex, hideButton = false, buttonAriaLabel = null}) => `
  <button
    class="${css.icon} ${iconClass} ${css.dropdownButton}"
    title="${title}"
    ${tabIndexForButton !== null ? `tabindex="${tabIndexForButton}"` : ''}
    ${hideButton ? 'aria-hidden="true"' : ''}
    ${buttonAriaLabel ? `aria-label="${buttonAriaLabel}"` : ''}
    >${icon || ''}</button>
  ${links(items, {
    list: items => items.length > scrollDropdownWhenItemsAmountIsBiggerThen ? [css.dropdown, css.limitHeight] : css.dropdown,
    item: css.dropdownItem,
    itemContent: css.dropdownItemContent
  }, null, tabIndex, {
    role: 'menu'
  }, null, {
    role: 'menuitem'
  })}
`;

export default ({mainLinks, userLinks, user, t, config, location = null, isMobile}) => `
  <a href="${homeLink(config.language)}" class="${css.logo}" title="${t('title_wix_logo')}" tabindex="${config.tabIndex[0]}"></a>
  ${!config.hideMainLinksOnDesktop ?
    `<ul class="${css.navigation}" role="menu" data-hook="header-menu">
      ${mainLinks.map(item => `
        <li class="${css.navigationItem} ${item.subs && item.subs.length ? css.hasDropdown : ''}">
          ${linkContent(item, {itemContent: css.navigationItemContent}, config.tabIndex[0], {role: 'menuitem'})}
          ${item.subs && item.subs.length ?
    dropdown(item.subs, {
      title: '',
      icon: iconsArrowDown,
      tabIndex: config.tabIndex[0],
      tabIndexForButton: -1,
      hideButton: true
    }) : ''}
        </li>
      `).join('')}
    </ul>` : ''
}
  ${user ? `
    <nav class="${css.user} ${css.hasDropdown}" tabindex="${config.tabIndex[0]}" aria-label="${t('user_menu')}">
      <img src="${user.profileImage || defaultProfileImage(config)}" alt="${user.userName}" class="${css.userPic}" aria-hidden="true" id=${css.profileImage}>
      <div class="${css.userName}" aria-hidden="true">${user.userName}</div>
      ${dropdown(userLinks, {
    title: '',
    iconClass: css.iconInlineArrowDown,
    icon: iconsArrowDown,
    tabIndex: config.tabIndex[0],
    tabIndexForButton: -1
  })}
    </nav>
  ` : `
    ${!config.hideLanguagePickerOnDesktop ?
    `<div class="${css.languagePicker} ${css.hasDropdown}" data-hook="language-picker">
        ${dropdown(languagesMenu(config.supportedLanguages.filter(language => config.language !== language), location, config), {
    title: t('choose_language'),
    iconClass: css.iconInlineGlobe,
    icon: iconsGlobe,
    tabIndex: config.tabIndex[0]
  })}
      </div>` :
    ''
}
    <a
      href="${loginUrl(config, isMobile)}"
      title="${t('title_signin')}"
      class="${css.signinButton}"
      tabindex="${config.tabIndex[0]}"
      role="button"
      >${t('signin')}</a>
  `}
`;
